// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".load-placeholder[data-v-d6b5ff72]{margin-top:200px;height:450px}.provider-logo[data-v-d6b5ff72]{max-width:130px;max-height:70px}.provider-detail[data-v-d6b5ff72]{color:var(--secondary-color);font-size:14px}.provider-discounts[data-v-d6b5ff72]{clear:both}.provider-tags[data-v-d6b5ff72]{margin-top:-16px}h1[data-v-d6b5ff72]{color:var(--primary-color);font-size:32px}.provider-description[data-v-d6b5ff72]{text-align:justify;margin-bottom:16px}", ""]);
// Exports
module.exports = exports;
